const attemptUpgradingThumbnail = imageNode => {
  const THUMBNAIL_UNAVAILABLE_IMAGE_WIDTH = 120
  const THUMBNAIL_UNAVAILABLE_IMAGE_HEIGHT = 90

  if (imageNode && window.matchMedia('screen and (min-width: 768px)').matches) {
    const webpUrl = `https://img.youtube.com/vi/${imageNode.dataset?.videoId}/maxresdefault.jpg`
    const img = new Image()
    img.fetchPriority = 'low'
    img.referrerpolicy = 'origin'
    img.src = webpUrl
    img.style.display = 'none'
    img.onload = e => {
      const noAvailablePoster =
        e.target.naturalHeight == THUMBNAIL_UNAVAILABLE_IMAGE_HEIGHT &&
        e.target.naturalWidth == THUMBNAIL_UNAVAILABLE_IMAGE_WIDTH
      if (!noAvailablePoster) {
        imageNode.style.backgroundImage = `url("${webpUrl}")`
      }
    }
  }
}

function adjustVideos() {
  const youtubeVideoElements = document.querySelectorAll('.js-youtube-video')
  for (const youtubeVideoElement of youtubeVideoElements) {
    const hasGallery = youtubeVideoElement.dataset.gallery === 'active'
    const mainElement = youtubeVideoElement.querySelector(
      '.js-youtube-video-main'
    )

    const generateIframe = videoId => {
      return `<iframe src="https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1;modestbranding=1;rel=0" class="[ f-pos-ab f-p-a-0 ] YoutubeVideo-play" style="border: 0;" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />`
    }
    const initialButton = mainElement.querySelector('button')
    const { videoId } = initialButton.dataset

    initialButton.addEventListener('click', event => {
      event.preventDefault()

      _wt({
        category: 'video',
        action: 'start',
        values: [
          {
            type: 'url',
            value: `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1;modestbranding=1;rel=0`
          }
        ]
      })

      mainElement.innerHTML = generateIframe(videoId)
    })

    attemptUpgradingThumbnail(initialButton)

    if (hasGallery) {
      const thumbButtons = youtubeVideoElement.querySelectorAll(
        '.js-youtube-video-thumb'
      )

      for (const thumbButton of thumbButtons) {
        thumbButton.addEventListener('click', event => {
          event.preventDefault()
          const { videoId: thumbVideoId } = thumbButton.dataset
          _wt({
            category: 'video',
            action: 'start',
            values: [
              {
                type: 'url',
                value: `https://www.youtube-nocookie.com/embed/${thumbVideoId}?autoplay=1;modestbranding=1;rel=0`
              }
            ]
          })

          mainElement.innerHTML = generateIframe(thumbVideoId)
        })
      }
    }
  }
}

const handleReadyStateChange = () => {
  if (document.readyState === 'complete') {
    adjustVideos()
    document.removeEventListener('readystatechange', handleReadyStateChange)
  }
}

if (document.readyState === 'complete') {
  adjustVideos()
} else {
  document.addEventListener('readystatechange', handleReadyStateChange)
}
